import { type ReactNode } from 'react';

import { cn } from '@/lib/utils';

export function CustomSubtitle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <p className={cn('text-lead text-ink-soft max-w-2xl mx-auto', className)}>{children}</p>;
}
